// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";
import { OverlayPanelModule } from "primeng/overlaypanel";

// BBWT
import { ApiVersionComponent, AppComponent, AuthenticatorBannerComponent, IdleBannerComponent } from "./components";
import { MaintenanceModule } from "@main/maintenance";
import { ApiVersionService } from "./api-version.service";
import { AppOfflineIndicatorComponent } from "../pwa/app-offline-indicator.component";
import { CookieModule } from "@main/cookie/cookie.module";
import { RuntimeEditorModule } from "../runtime-editor";
import {
    UltimaComponent,
    UltimaTopbarComponent,
    UltimaInlineProfileComponent,
    UltimaMenuComponent,
    UltimaMenuItemComponent,
    UltimaFooterComponent
} from "./components/ultima";
import {
    VeronaComponent,
    VeronaTopbarComponent,
    VeronaMenuComponent,
    VeronaMenuItemComponent,
    VeronaFooterComponent
} from "./components/verona";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { NotificationModule } from "@main/notification/notification.module";
import { PatientSwitchModule } from "./components/patient-switch/patient-switch.module";
import { UserSwitchComponent as UltimaUserSwitchCompononent } from "./components/ultima/user-switch.component";
import { FormIOModuleService } from "@main/formio/services/formio-module.service";
import { BbFormIOModule } from "@features/bb-formio";
import { EpisodeModule } from "@project/episode/episode.module";
import { FormIOInboxModule } from "@main/formio-inbox/formio-inbox.module";
import { MultiUserFormService } from "@main/formio/multi-user-form/services/multi-user-form.service";
import { FormioViewerService } from "@main/formio/services/formioViewer.service";
import { AfterLoginModule } from "./components/after-login/after-login.module";
import { IncompleteDataPromptComponent } from "../incomplete-data/incomplete-data-prompt.component";
import { IncompleteDataWarningComponent } from "@main/incomplete-data/incomplete-data-warning.component";
import { PendingMatchingProfilesDialogComponent } from "@project/patient-matching-profiles/pending-matching-profiles.dialog.component";
import { PdfExportingModule } from "@main/pdf-exporting/pdf-exporting.module";
import { BrandingModule } from "./components/branding/branding.module";
import { GlobalDroTermsComponent } from "@project/prescription/globaldro/globaldro-terms.component";

@NgModule({
    declarations: [
        AppComponent,
        ApiVersionComponent,
        AuthenticatorBannerComponent,
        IdleBannerComponent,
        AppOfflineIndicatorComponent,
        UltimaComponent,
        UltimaTopbarComponent,
        UltimaInlineProfileComponent,
        UltimaMenuComponent,
        UltimaMenuItemComponent,
        UltimaFooterComponent,
        VeronaComponent,
        VeronaTopbarComponent,
        VeronaMenuComponent,
        VeronaMenuItemComponent,
        VeronaFooterComponent,
        UltimaUserSwitchCompononent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimeNgModule,
        OverlayPanelModule,
        // BBWT
        MaintenanceModule,
        CookieModule,
        RuntimeEditorModule,
        MiproSharedModule,
        NotificationModule,
        PatientSwitchModule,
        BbFormIOModule,
        EpisodeModule,
        FormIOInboxModule,
        AfterLoginModule,
        IncompleteDataPromptComponent,
        IncompleteDataWarningComponent,
        PendingMatchingProfilesDialogComponent,
        PdfExportingModule,
        BrandingModule,
        GlobalDroTermsComponent
    ],
    exports: [AppComponent],
    providers: [ApiVersionService, FormIOModuleService, MultiUserFormService, FormioViewerService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLayoutModule {}
